import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd';
import { SetService, PageService } from 'ngx-block-core';

@Component({
  selector: 'app-auto-test2',
  templateUrl: './auto-test.component.html',
  styleUrls: ['./auto-test.component.less']
})
export class AutoTestComponent implements OnInit {
  @Input() tform: FormGroup;
  @Input() formGroupData: any;
  @Input() buttonId;
  @Input() spinId;
  usenext = false;
  送检按钮id = "SUCUCySysBlockSucu05button001000920191003000851";
  送检input = "SUCUCySysBlockSucu05button001000920191003000851";
  送检From = "SUCUCsysModule20191003001056";
  暂停 = false;
  delay = 1000;
  nzSpinning = false;
  stop = false;
  dataList = [
    {
      steps: [
      ],
    }
  ]
  // AOI_SUZ15SMT-N
  // 20419440001,20419440002,20419440003,20419440004,20419440005,20419440006,20419440007,20419440008,20419440009,20419440010,20419440011,204194400012,204194400013,204194400014,204194400015
  blockList = [];

  constructor(private message: NzMessageService, private setService: SetService, private pageService: PageService) { }

  ngOnInit() {
    console.log('test-tform', this.tform);
    console.log('test-formGroupData', this.formGroupData, JSON.stringify(this.formGroupData));
    this.getBlockList();
    this.setService.pageDatas['AUTOTEST_CHLINE'] = 'no';
    this.暂停 = true;
    // this.setService.pageDatas['AUTOTEST_XRAY'] = 'yes';
  }
  getBlockList() {
    for (const blockid in this.formGroupData.datas.nzForm.nzFormGroupDatas) {
      if (this.formGroupData.datas.nzForm.nzFormGroupDatas.hasOwnProperty(blockid)) {
        const element = this.formGroupData.datas.nzForm.nzFormGroupDatas[blockid];
        this.blockList.push(
          {
            value: element.nzKey,
            label: element.nzLabel,
          }
        )
      }
    }
  }
  addStep(index = 0) {
    this.dataList[index].steps.push({
      blockId: null,
      valueType: 'more',//one
      value: '',//one
      valueList: []
    });
  }
  deleteStep(index, i = 0) {
    this.dataList[i].steps.splice(index, 1);
  }

  async do() {
    this.nzSpinning = true;
    this.stop = false;
    for (let index = 0; index < this.dataList.length; index++) {
      const data = this.dataList[index];
      //计算长度
      let length = 1;
      for (let j = 0; j < data.steps.length; j++) {
        const step = data.steps[j];
        // if (this.tform.get(step.blockId).value === step.value)
        if (step.valueType === 'more') {
          try {
            step.valueList = step.value.split(",");
            if (length === 1) length = step.valueList.length;
            else {
              if (length !== step.valueList.length) {
                this.message.create('error', `数据长度不一致`);
                return;
              }
            }
          } catch (error) {
            this.message.create('error', `转换失败` + step.value);
            return;
          }
        }
      }
      console.log('do-length', length);

      for (let i = 0; i < length; i++) {
        //赋值
        console.log('do-赋值', i);
        for (let j = 0; j < data.steps.length; j++) {
          const step = data.steps[j];
          if (step.valueType === 'one') {
            if (this.tform.get(step.blockId).value !== step.value) {
              this.tform.get(step.blockId).patchValue(step.value);
            }
          } else {
            if (this.tform.get(step.blockId).value !== step.valueList[0]) {
              this.tform.get(step.blockId).patchValue(step.valueList[0]);
            }
          }
        }
        console.log('do-等待校验执行', i);
        //等待校验通过并执行
        for (let j = 0; j <= 10; j--) {
          await this.sleep(100);
          if (this.tform.valid) {
            this.setService.sendEvent(this.buttonId, 'click');
            break;
          }
          if (this.stop) {
            this.nzSpinning = false;
            return;
          }
        }

        if (this.usenext) {
          for (let j = 0; j <= 10; j--) {
            await this.sleep(100);
            if (this.暂停 == false) {
              this.暂停 = true;
              break;
            }
            if (this.stop) {
              this.nzSpinning = false;
              return;
            }
          }
        } else {
          // 等待
          console.log('do-等待转圈', i);
          for (let j = 0; j <= 10; j--) {
            console.log("this.pageService.pageSpin[" + this.spinId + "]['div']", this.pageService.pageSpin['SUCUCsysModule20190327000432']['div'])
            if (this.pageService.pageSpin[this.spinId]['div']) {
              await this.sleep(100);
              if (this.stop) {
                this.nzSpinning = false;
                return;
              }
            } else {
              break;
            }
          }
        }

        console.log('do-删除more数据', i);
        //删除more数据
        for (let j = 0; j < data.steps.length; j++) {
          const step = data.steps[j];
          if (step.valueType === 'more') {
            step.valueList.splice(0, 1);
          }
        }
        await this.sleep(this.delay);
        // 暂停=true;
        if (this.stop) {
          this.nzSpinning = false;
          return;
        }
      }




    }
    this.nzSpinning = false;
  }
  stopDo() {
    this.stop = true;
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  patchValue() {

  }
  // data[0] =
  //   {
  //     "CSYS_RETURN": "SUCCESS",
  //     "RESOURCE_CODE": "AOI_SUZ15SMT-A",
  //     "PRO_BAR_CODE": "ABC0117",
  //     "CSYS_INFO": "过站完成",
  //     "CSYS_POT_TRS_ID": "LHCsysPotTrs20191108006690",
  //     //添加
  //     "DRAWER":[]//内容和['logData']['drawer']一致
  //   }

  next() {
    this.暂停 = false;
  }
  // AOI_SUZ15SMT-J
  // QC_SMT_SUZ15SMT-J
  // <app-auto-test [tform]="form1" [formGroupData]="formGroupData1" spinId="SUCUCsysModule20190327000432"
  // buttonId="SUCUCySysBlockSucu05button001000920190426000615"></app-auto-test>
  //   import { AutoTestComponent } from './auto-test/auto-test.component';
}
// SPI_SUZ15SMT-N
// SPI_SUZ15SMT - A
// AOI_SUZ15SMT - A
// ABC0001, ABC0002, ABC0003, ABC0004, ABC0005, ABC0006, ABC0007, ABC0008, ABC0009, ABC0010, ABC0011, ABC0012, ABC0013, ABC0014, ABC0015, ABC0016, ABC0017, ABC0018, ABC0019, ABC0020, ABC0021, ABC0022, ABC0023, ABC0024, ABC0025, ABC0026, ABC0027, ABC0028, ABC0029, ABC0030, ABC0031, ABC0032, ABC0033, ABC0034, ABC0035, ABC0036, ABC0037, ABC0038, ABC0039, ABC0040, ABC0041, ABC0042, ABC0043, ABC0044, ABC0045, ABC0046, ABC0047, ABC0048, ABC0049, ABC0050, ABC0051, ABC0052, ABC0053, ABC0054, ABC0055, ABC0056, ABC0057, ABC0058, ABC0059, ABC0060, ABC0061, ABC0062, ABC0063, ABC0064, ABC0065, ABC0066, ABC0067, ABC0068, ABC0069, ABC0070, ABC0071, ABC0072, ABC0073, ABC0074, ABC0075, ABC0076, ABC0077, ABC0078, ABC0079, ABC0080, ABC0081, ABC0082, ABC0083, ABC0084, ABC0085, ABC0086, ABC0087, ABC0088, ABC0089, ABC0090, ABC0091, ABC0092, ABC0093, ABC0094, ABC0095, ABC0096, ABC0097, ABC0098, ABC0099, ABC0100
// ABC0101, ABC0102, ABC0103, ABC0104, ABC0105, ABC0106, ABC0107, ABC0108, ABC0109, ABC0110, ABC0111, ABC0112, ABC0113, ABC0114, ABC0115, ABC0116, ABC0117, ABC0118, ABC0119, ABC0120, ABC0121, ABC0122, ABC0123, ABC0124, ABC0125, ABC0126, ABC0127, ABC0128, ABC0129, ABC0130, ABC0131, ABC0132, ABC0133, ABC0134, ABC0135, ABC0136, ABC0137, ABC0138, ABC0139, ABC0140, ABC0141, ABC0142, ABC0143, ABC0144, ABC0145, ABC0146, ABC0147, ABC0148, ABC0149, ABC0150, ABC0151, ABC0152, ABC0153, ABC0154, ABC0155, ABC0156, ABC0157, ABC0158, ABC0159, ABC0160, ABC0161, ABC0162, ABC0163, ABC0164, ABC0165, ABC0166, ABC0167, ABC0168, ABC0169, ABC0170, ABC0171, ABC0172, ABC0173, ABC0174, ABC0175, ABC0176, ABC0177, ABC0178, ABC0179, ABC0180, ABC0181, ABC0182, ABC0183, ABC0184, ABC0185, ABC0186, ABC0187, ABC0188, ABC0189, ABC0190, ABC0191, ABC0192, ABC0193, ABC0194, ABC0195, ABC0196, ABC0197, ABC0198, ABC0199, ABC0200
// ZXC0001,ZXC0002,ZXC0003,ZXC0004,ZXC0005,ZXC0006,ZXC0007,ZXC0008,ZXC0009,ZXC0010,ZXC0011,ZXC0012,ZXC0013,ZXC0014,ZXC0015,ZXC0016,ZXC0017,ZXC0018,ZXC0019,ZXC0020,ZXC0021,ZXC0022,ZXC0023,ZXC0024,ZXC0025,ZXC0026,ZXC0027,ZXC0028,ZXC0029,ZXC0030,ZXC0031,ZXC0032,ZXC0033,ZXC0034,ZXC0035,ZXC0036,ZXC0037,ZXC0038,ZXC0039,ZXC0040,ZXC0041,ZXC0042,ZXC0043,ZXC0044,ZXC0045,ZXC0046,ZXC0047,ZXC0048,ZXC0049,ZXC0050,ZXC0051,ZXC0052,ZXC0053,ZXC0054,ZXC0055,ZXC0056,ZXC0057,ZXC0058,ZXC0059,ZXC0060,ZXC0061,ZXC0062,ZXC0063,ZXC0064,ZXC0065,ZXC0066,ZXC0067,ZXC0068,ZXC0069,ZXC0070,ZXC0071,ZXC0072,ZXC0073,ZXC0074,ZXC0075,ZXC0076,ZXC0077,ZXC0078,ZXC0079,ZXC0080,ZXC0081,ZXC0082,ZXC0083,ZXC0084,ZXC0085,ZXC0086,ZXC0087,ZXC0088,ZXC0089,ZXC0090,ZXC0091,ZXC0092,ZXC0093,ZXC0094,ZXC0095,ZXC0096,ZXC0097,ZXC0098,ZXC0099,ZXC0100
// { "code": 200, "message": "SUCCESS", "param": { "access_token": "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJMSENzeXNVc2VyMjAxOTEwMjMwODI4MTg2NzMwMDAxODkiLCJpYXQiOjE1NzMxOTI1NjcsInN1YiI6IlJPTkdZQU8iLCJleHAiOjE1NzMxOTI2ODd9.RIBeknq1rOCPrewZD1Qfurr_jpNhxMzUvRBdB1ZgXfM", "refresh_token": "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJMSENzeXNVc2VyMjAxOTEwMjMwODI4MTg2NzMwMDAxODkiLCJpYXQiOjE1NzMxODkyNjksInN1YiI6IlJPTkdZQU8iLCJleHAiOjE1NzMyNzU2Njl9.XNYaQFZkQhB5MEjdG0PT7YmxrovYi8FnNR2Ag4xl4c8" }, "data": [{ "CSYS_RETURN": "SUCCESS", "RESOURCE_CODE": "AOI_SUZ15SMT-A", "PRO_BAR_CODE": "ABC0117", "CSYS_INFO": "过站完成", "CSYS_POT_TRS_ID": "LHCsysPotTrs20191108006690" }], "extraData": "", "logData": "", "modalData": "", "resourceVerificationBean": "" }